import { FaInstagram } from 'react-icons/fa';

const BottomNavbar = () => {
    return (
        <nav style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            width: '100%',
            background: '#222',
            color: "#0000FF",
            textAlign: 'center',
            padding: '12px 0',
            fontSize: '16px',
            boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
            backgroundColor: 'beige',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '1rem'
        }}>
            <a
                href="mailto:contacto@timelinestudio.es"
                style={{ color: "#ed4e01", textDecoration: "none", display: "flex", alignItems: "center" }}
                aria-label="Enviar email a contacto@timelinestudio.es"
            >
                contacto@timelinestudio.es
            </a>
            <a
                href="https://www.instagram.com/timeline_estudio?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#ed4e01", marginLeft: "8px", display: "flex", alignItems: "center" }}
                aria-label="Abrir Instagram de timeline estudio"
            >
                <FaInstagram size={24} />
            </a>
        </nav>
    );
};

export default BottomNavbar;